import React from 'react';
import { Link } from 'react-router-dom';
import './App.css';

function Privacy() {
  return (
    <div className="App">
      <header className="App-header">
        <h1>Privacy Policy</h1>
        
        <div style={{ margin: '20px', textAlign: 'left', maxWidth: '800px' }}>
          <section style={{ marginBottom: '30px' }}>
            <p style={{ marginBottom: '20px' }}>
              <Link to="/" style={{ color: '#61dafb', textDecoration: 'none' }}>← Back to Home</Link>
            </p>

            <h2>Introduction</h2>
            <p>
              This privacy policy describes how we collect, use, and protect your personal information 
              when you use our Azure Static Web App POC application.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Information We Collect</h2>
            <p>When you authenticate with our application, we may collect:</p>
            <ul style={{ marginLeft: '20px' }}>
              <li>Your name and email address from your authentication provider (GitHub or Facebook)</li>
              <li>Your user ID from the authentication provider</li>
              <li>Profile information you've made public on your authentication provider</li>
              <li>Authentication tokens necessary to verify your identity</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>How We Use Your Information</h2>
            <p>We use the collected information to:</p>
            <ul style={{ marginLeft: '20px' }}>
              <li>Authenticate your identity and provide access to the application</li>
              <li>Personalize your experience within the application</li>
              <li>Maintain the security and integrity of our services</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Third-Party Authentication Providers</h2>
            <p>
              We use third-party authentication services (GitHub and Facebook) to verify your identity. 
              When you choose to authenticate through these services, you are subject to their respective 
              privacy policies:
            </p>
            <ul style={{ marginLeft: '20px' }}>
              <li>
                <a href="https://docs.github.com/en/site-policy/privacy-policies/github-privacy-statement" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   style={{ color: '#61dafb' }}>
                  GitHub Privacy Statement
                </a>
              </li>
              <li>
                <a href="https://www.facebook.com/privacy/policy/" 
                   target="_blank" 
                   rel="noopener noreferrer"
                   style={{ color: '#61dafb' }}>
                  Facebook Privacy Policy
                </a>
              </li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Data Storage and Security</h2>
            <p>
              Your authentication data is managed by Azure Static Web Apps and follows Microsoft Azure's 
              security and privacy standards. We implement appropriate technical and organizational measures 
              to protect your personal information.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Your Rights</h2>
            <p>You have the right to:</p>
            <ul style={{ marginLeft: '20px' }}>
              <li>Access the personal information we hold about you</li>
              <li>Request correction of inaccurate information</li>
              <li>Request deletion of your information</li>
              <li>Withdraw consent for data processing at any time</li>
            </ul>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Cookies and Tracking</h2>
            <p>
              Our application uses authentication cookies to maintain your session. These cookies are 
              essential for the application to function properly and are managed by Azure Static Web Apps.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Changes to This Policy</h2>
            <p>
              We may update this privacy policy from time to time. Any changes will be posted on this page 
              with an updated revision date.
            </p>
          </section>

          <section style={{ marginBottom: '30px' }}>
            <h2>Contact Information</h2>
            <p>
              If you have any questions or concerns about this privacy policy or our data practices, 
              please contact us through the appropriate channels.
            </p>
          </section>

          <p style={{ marginTop: '40px', fontSize: '0.9em', color: '#888' }}>
            Last updated: {new Date().toLocaleDateString()}
          </p>

          <p style={{ marginTop: '20px' }}>
            <Link to="/" style={{ color: '#61dafb', textDecoration: 'none' }}>← Back to Home</Link>
          </p>
        </div>
      </header>
    </div>
  );
}

export default Privacy;
